import { useParams } from "@tanstack/react-router";

export const useCompanySlug = () => {
  const { companySlug } = useParams({ strict: false });

  if (!companySlug) {
    throw new Error(
      "No company slug defined, only use this hook in /_authed/$companySlug",
    );
  }

  return companySlug;
};
